import React from 'react';

function HeroHome() {

  //const [videoModalOpen, setVideoModalOpen] = useState(false);

  return (
    <section className="relative">

      {/* Illustration behind hero content */}
      <div className="absolute hidden md:block bottom-0 pointer-events-none animate-float left-0 right-0" aria-hidden="true">
        <svg width="100%" height="578" viewBox="0 0 1360 578" xmlns="http://www.w3.org/2000/svg">
          <defs>
            <linearGradient x1="50%" y1="0%" x2="50%" y2="100%" id="illustration-01">
              <stop stopColor="#FFF" offset="0%" />
              <stop stopColor="#EAEAEA" offset="77.402%" />
              <stop stopColor="#DFDFDF" offset="100%" />
            </linearGradient>
          </defs>
          <g fill="url(#illustration-01)" fillRule="evenodd">
            <circle cx="1232" cy="128" r="128" />
            <circle cx="155" cy="443" r="64" />
          </g>
        </svg>
      </div>

      <div className="max-w-6xl mx-auto">

        {/* Hero content */}
        <div className="pt-32 md:pt-40">

          {/* Section header */}
          <div className="text-center pb-5">
            <h1 className="text-5xl md:text-6xl font-extrabold leading-tighter tracking-tighter mb-4" data-aos="zoom-y-out">Google Drive <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-500 to-teal-400">Supercharged</span></h1>
            <div className="max-w-3xl mx-auto">
              <p className="text-xl text-gray-600 mb-8" data-aos="zoom-y-out" data-aos-delay="150">The <span className="bg-clip-text text-transparent bg-gradient-to-r from-orange-500 to-red-400">ultimate collection</span> of tools to supercharge your Google Drive experience</p>
            </div>
          </div>
        </div>

      </div>
    </section >
  );
}

export default HeroHome;